/**
 * Adds a close button to airports list dropdown
 *
 * @param {HTMLElement} field 
 */
export const addCloseButtonToAirportsDropdownList = field => {
  if (!field) return
  if (field.querySelector('.close')) return
  const container = field.querySelector('.dropdown-menu')
  if (!container) return
  const selectpicker = field.querySelector('select')
  if (!selectpicker) return

  const cross = document.createElement('button')
  cross.innerText = '×'
  cross.setAttribute('type', 'button')
  cross.setAttribute('aria-hidden', true)
  cross.classList.add('close')
  container.insertAdjacentElement('beforeend', cross)
}

export const addCloseButtonToAllAirportsDropdownLists = () => {
  document.querySelectorAll('.custom-select-airport').forEach(addCloseButtonToAirportsDropdownList)
}



// WEBPACK FOOTER //
// ./src/modules/customizations/airport.js